import React, { useState } from 'react';
import {
  UseCaseWrapper,
  UseCaseHeader,
  Subtitle,
  CategoriesWrapper,
  CategoryButton,
  ContainerUseCase,
  ContentWrapper,
  ContentLeft,
  ContentRight,
  SectionTitle,
  Description,
  BtnCTA,
  StyledContainer,
  HeadlineStyle,
  ImageWrapper,
  StyledLink,
} from './CustomerUseCase.style';
import { PrismicRichText } from '@prismicio/react';
import Container from 'common/components/UI/Container';
import Image from 'next/image';
import Link from 'next/link';

const CustomerUseCase = ({ slice }) => {
  const { primary = {}, items = [] } = slice || {};
  const [activeIndex, setActiveIndex] = useState(0);

  const handleCategoryClick = (index) => {
    setActiveIndex(index);
  };

  const activeItem = items[activeIndex] || {};
  return (
    <Container>
      <UseCaseWrapper>
        <UseCaseHeader>
          <PrismicRichText
            field={primary.headline}
            components={{
              paragraph: ({ children }) => (
                <HeadlineStyle variant="h2">{children}</HeadlineStyle>
              ),
            }}
          />
          <Subtitle>{primary.description}</Subtitle>
        </UseCaseHeader>
        <StyledContainer>
          <ContainerUseCase>
            <CategoriesWrapper>
              {items.map((item, index) => (
                <CategoryButton
                  key={index}
                  active={index === activeIndex}
                  onClick={() => handleCategoryClick(index)}
                >
                  {item.label}
                </CategoryButton>
              ))}
            </CategoriesWrapper>
          </ContainerUseCase>

          <ContentWrapper>
            <ContentLeft>
              {activeItem.image && activeItem.image.url && (
                <ImageWrapper>
                  <Image
                    src={activeItem.image.url}
                    alt={
                      activeItem.image.alt || `Image for ${activeItem.label}`
                    }
                    width={400}
                    height={400}
                    style={{ objectFit: 'contain' }}
                    layout="responsive"
                  />
                </ImageWrapper>
              )}
            </ContentLeft>
            <ContentRight>
              <SectionTitle>
                <PrismicRichText field={activeItem.title} />
              </SectionTitle>
              <Description>
                <PrismicRichText field={activeItem.description} />
              </Description>
              <Link href="https://app.swiftask.ai" passHref legacyBehavior>
                <StyledLink target="_blank" rel="noopener noreferrer">
                  <BtnCTA>{activeItem.cta_text}</BtnCTA>
                </StyledLink>
              </Link>
            </ContentRight>
          </ContentWrapper>
        </StyledContainer>
      </UseCaseWrapper>
    </Container>
  );
};

export default CustomerUseCase;
